import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleInput from "../../../../modules/SimpleInput";
import Api from "../../../../Services/Api";
import { fetchDataAsync } from "../../../../Services/Utils";
import {
  HttpStatus,
  INITIAL_DATE,
  INITIAL_PAGINATION,
} from "../../../common/Constants";
import { getStockTableConfig } from "./config";
import InventoryPartStockInfo from "./inventoryPartStockInfo";
import moment from "moment";
import { defaultTableChange } from "../../../../modules/custom/customTable";

class InventoryPartStock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagination: INITIAL_PAGINATION,
      dataTable: [],
      keyword: null,
      search: {
        startDate: INITIAL_DATE,
        endDate: INITIAL_DATE,
      },
      detailHistory: {
        visible: false,
        barcode: null,
      },
      stockInfo: {
        visible: false,
        data: null,
      },
    };
  }

  componentDidMount() {
    this.fetchDataDetail();
  }

  fetchDataDetail = async (start, end) => {
    const { onTriggerLoading, selectedData, setError } = this.props;
    if (!selectedData) return;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getStockInventoryPart,
      menuName: "Inventory Part",
      setError: setError,
      args: {
        startDate: start || INITIAL_DATE,
        endDate: end || INITIAL_DATE,
        partCode: selectedData?.partCode,
        locator: selectedData?.locator,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
      }));
    }
  };

  getTableConfig = () => {
    return getStockTableConfig({
      onClickItem: this.handlePartStockVisibility,
    });
  };

  handleChangeSearch = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      search: {
        ...prev.search,
        [name]: value,
      },
    }));
  };

  handleDetailHistoryVisibility = (barcode) => {
    this.setState((prev) => ({
      ...prev,
      detailHistory: {
        visible: !prev.detailHistory.visible,
        barcode: barcode,
      },
    }));
  };

  handlePartStockVisibility = (index, trxType) => {
    this.setState((prev) => ({
      ...prev,
      stockInfo: {
        visible: !prev.stockInfo.visible,
        data: index !== undefined
          ? {
              trxType,
              ...prev.dataTable[index],
            }
          : null,
      },
    }));
  };

  handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: tableState.page + 1,
          }
      }));
  };
  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    const { onClickClose, visible, selectedData } = this.props;
    const { pagination, dataTable, search, stockInfo } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="Kartu Stock Part"
          visible={visible}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <div className="grid grid-2x grid-mobile-none gap-20px margin-bottom-20px">
                <div id="grid-1">
                  <SimpleInput
                    id="input_text_kode_part"
                    name="partCode"
                    label="Kode Part"
                    readOnly
                    value={selectedData?.partCode}
                  />
                  <SimpleInput
                    id="input_text_nama_part"
                    name="partName"
                    label="Nama Part"
                    readOnly
                    value={selectedData?.partName}
                  />
                </div>
                <div id="grid-2">
                  <SimpleInput
                    id="input_text_kategori_part"
                    name="category"
                    label="Kategori Part"
                    readOnly
                    value={selectedData?.category}
                  />
                  <SimpleInput
                    id="input_text_locator"
                    name="locator"
                    label="Locator"
                    readOnly
                    value={selectedData?.locatorName}
                  />
                </div>
              </div>
              <FlexView vAlignContent="center" style={{ gap: "15px" }}>
                <h4 className="txt-site txt-12 txt-main txt-bold margin-bottom-20px">
                  Periode
                </h4>
                <SimpleDate
                  id="input_start_Date"
                  name="startDate"
                  date={search.startDate}
                  maxDate={search.endDate}
                  onChange={(value) =>
                    this.handleChangeSearch("startDate", moment(value).format("DD-MM-YYYY"))
                  }
                />
                <h4 className="txt-site txt-12 txt-main txt-bold margin-bottom-20px">
                  s/d
                </h4>
                <SimpleDate
                  id="input_end_date"
                  name="endDate"
                  date={search.endDate}
                  minDate={search.startDate}
                  nextDate
                  onChange={(value) =>
                    this.handleChangeSearch("endDate", moment(value).format("DD-MM-YYYY"))
                  }
                />
                <SimpleButton
                  text="CARI"
                  id="btn_search_qr"
                  className="margin-bottom-20px"
                  onClick={() =>
                    this.fetchDataDetail(search.startDate, search.endDate)
                  }
                />
              </FlexView>
              <SimpleDataTable
                key={`${pagination.totalData}-${pagination.page}-${pagination.limit}`}
                data={dataTable}
                columns={this.getTableConfig()}
                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                rowsPerPage={pagination.limit}
                toCount={pagination.totalData}
                page={pagination.page - 1}
              />
              {stockInfo.visible && (
                <InventoryPartStockInfo
                  {...this.props}
                  visible={stockInfo.visible}
                  selectedData={{ ...selectedData, ...(stockInfo.data || {}) }}
                  onClickClose={this.handlePartStockVisibility}
                />
              )}
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default InventoryPartStock;
